import { OmakaseColors } from 'theme/colors/omakaseColors';
import { css } from '@emotion/react';
import { omakase } from '@tock/tokens';

export const sansRegularFamily = 'var(--font-family-sans-regular)';
export const sansCondensedFamily = 'var(--font-family-sans-condensed)';

export type OmakaseTypographyVariant =
  | 'decorative'
  | 'heading01'
  | 'heading02'
  | 'heading03'
  | 'heading04'
  | 'overline'
  | 'body01'
  | 'body01Strong'
  | 'body02'
  | 'body02Strong'
  | 'caption'
  | 'captionStrong';

export type OmakaseTextColors = Pick<
  OmakaseColors,
  | 'fgDefault'
  | 'fgSubtle'
  | 'fgDisabled'
  | 'fgContrast'
  | 'fgPrimaryBase'
  | 'fgDangerBase'
  | 'fgSuccessBase'
  | 'fgWarningBase'
>;

export type OmakaseTextColorInherit = 'inherit';

export type OmakaseTextColorsWithInherit = keyof OmakaseTextColors | OmakaseTextColorInherit;

const { typography } = omakase;

export const getTypographyVariant = (variant: OmakaseTypographyVariant) => {
  switch (variant) {
    case 'decorative':
      return css`
        font-family: ${typography.decorative.fontFamily};
        font-size: ${typography.decorative.fontSize};
        line-height: ${typography.decorative.lineHeight};
        text-transform: uppercase;
        letter-spacing: normal;
        text-transform: uppercase;
      `;

    case 'heading01':
      return css`
        font-family: ${typography.heading01.fontFamily};
        font-size: ${typography.heading01.fontSize};
        line-height: ${typography.heading01.lineHeight};
        font-weight: ${typography.heading01.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'heading02':
      return css`
        font-family: ${typography.heading02.fontFamily};
        font-size: ${typography.heading02.fontSize};
        line-height: ${typography.heading02.lineHeight};
        font-weight: ${typography.heading02.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'heading03':
      return css`
        font-family: ${typography.heading03.fontFamily};
        font-size: ${typography.heading03.fontSize};
        line-height: ${typography.heading03.lineHeight};
        font-weight: ${typography.heading03.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'heading04':
      return css`
        font-family: ${typography.heading04.fontFamily};
        font-size: ${typography.heading04.fontSize};
        line-height: ${typography.heading04.lineHeight};
        font-weight: ${typography.heading04.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'overline':
      return css`
        font-family: ${typography.overline.fontFamily};
        font-size: ${typography.overline.fontSize};
        line-height: ${typography.overline.lineHeight};
        font-weight: ${typography.overline.fontWeight};
        letter-spacing: 2px;
        text-transform: uppercase;
      `;

    case 'body01':
      return css`
        font-family: ${typography.body01.fontFamily};
        font-size: ${typography.body01.fontSize};
        line-height: ${typography.body01.lineHeight};
        font-weight: ${typography.body01.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'body01Strong':
      return css`
        font-family: ${typography.body01Strong.fontFamily};
        font-size: ${typography.body01Strong.fontSize};
        line-height: ${typography.body01Strong.lineHeight};
        font-weight: ${typography.body01Strong.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'body02':
      return css`
        font-family: ${typography.body02.fontFamily};
        font-size: ${typography.body02.fontSize};
        line-height: ${typography.body02.lineHeight};
        font-weight: ${typography.body02.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'body02Strong':
      return css`
        font-family: ${typography.body02Strong.fontFamily};
        font-size: ${typography.body02Strong.fontSize};
        line-height: ${typography.body02Strong.lineHeight};
        font-weight: ${typography.body02Strong.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'caption':
      return css`
        font-family: ${typography.caption.fontFamily};
        font-size: ${typography.caption.fontSize};
        line-height: ${typography.caption.lineHeight};
        font-weight: ${typography.caption.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;

    case 'captionStrong':
      return css`
        font-family: ${typography.captionStrong.fontFamily};
        font-size: ${typography.captionStrong.fontSize};
        line-height: ${typography.captionStrong.lineHeight};
        font-weight: ${typography.captionStrong.fontWeight};
        letter-spacing: normal;
        text-transform: none;
      `;
  }
};
